<ng-container *appLoading="projectModel$ | withLoading | async as project">
  <div class="overview">
    <div class="info-header">
      <div class="name">
        <h3>{{ project.name }}</h3>
      </div>
      <div class="status">
        <app-status-badge [status]="project.status"> </app-status-badge>
        <app-separator></app-separator>
        @if ((project.numSystemsCompleted / project.numSystemsTotal) * 100; as progress) {
        <span class="progress-number"> {{ progress | number : '1.0-0' }} % </span>
        <app-progress-bar [progress]="progress"></app-progress-bar>
        } @else {
        <span class="progress-number"> 0 % </span>
        <app-progress-bar [progress]="0"></app-progress-bar>
        }
      </div>
      <div class="more">
        <button class="iconf-btn-blank minw150" [matMenuTriggerFor]="moreMenu">
          <mat-icon>settings</mat-icon>
          settings
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="editProject(project)">
            <mat-icon>edit</mat-icon>
            <span>edit project</span>
          </button>
          <button mat-menu-item (click)="addMember()">
            <mat-icon>person_add</mat-icon>
            <span>add members</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="togglePublic()">
            <mat-icon>visibility</mat-icon>
            <span>{{ project.public ? 'set as private' : 'set as public' }}</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="deleteProject()">
            <mat-icon>delete</mat-icon>
            <span>delete</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="overview-and-menu" style="display: flex; flex-direction: row">
      <app-project-overview [(projectNgModel)]="projectNgModel"></app-project-overview>
    </div>
  </div>
  <app-separator></app-separator>
  <ul class="tabs">
    <li class="tab">
      <a class="tab-link" [routerLink]="['/project', project.id]" [ngClass]="{ active: !isShowingMembers }">facilities</a>
      <a class="tab-link" [routerLink]="['./members']" [ngClass]="{ active: isShowingMembers }">members</a>
    </li>
  </ul>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</ng-container>
